<app-loader *ngIf="loader"></app-loader>
<div *ngIf="estimatedConsumption" class="mt-md-4">
  <div class="row">
    <div
      class="col mt-3 d-flex justify-content-start"
      style="align-items: center"
    >
      <img
        src="../../../assets/img/on.gif"
        alt="light"
        class="img-fluid light_img"
        *ngIf="lastTime === 'a few seconds ago'"
      />
      <img
        src="../../../assets/img/off.svg"
        alt="light"
        class="img-fluid light_img"
        *ngIf="lastTime !== 'a few seconds ago'"
      />
      <p class="ml-2 text_color mb-0" *ngIf="lastTime === 'a few seconds ago'">
        Right now, your <br />
        consumption is
      </p>
      <p class="ml-2 text_color mb-0" *ngIf="lastTime !== 'a few seconds ago'">
        Last updated {{ lastTime }}
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <h1 class="text-danger mb-0" *ngIf="liveActivePower">
        {{ liveActivePower }}
      </h1>
      <h1 class="text-danger mb-0" *ngIf="!liveActivePower">---</h1>
      <p class="text_color font-weight-bold">WATTS</p>
    </div>
  </div>
  <hr />
  <div class="row">
    <div class="col-5">
      <p class="text_color mb-0">Usage this month</p>
      <div class="local d-flex align-items-center">
        <img
          src="../../../assets/img/house.svg"
          alt="house"
          class="img-fluid"
        />
        <h3 class="text-danger mb-0 ml-1">
          {{ estimatedConsumption.thisMonthNetConsumption.toFixed(0) }}
        </h3>
      </div>
      <p class="text_color font-weight-bold ml-4">UNITS</p>
    </div>
    <div class="col-4">
      <p class="text_color mb-0">Locality avg.</p>
      <div class="local d-flex align-items-center">
        <img
          src="../../../assets/img/Ellipse.svg"
          alt="Ellipse"
          class="img-fluid"
        />
        <h3 class="text-danger mb-0 ml-1">----</h3>
      </div>
      <p class="text_color font-weight-bold ml-4">UNITS</p>
    </div>
  </div>
  <hr />
  <div class="row">
    <div class="col">
      <p class="text_color mb-0">Estimated consumption this month</p>
      <div class="local d-flex align-items-center">
        <img
          src="../../../assets/img/electric.svg"
          alt="electric"
          class="img-fluid"
        />
        <h2 class="text-danger mb-0 ml-1">
          {{ estimatedConsumption.thisMonthEstimatedConsumption.toFixed(0) }}
        </h2>
        <a routerLink="/budget">
          <img
            src="../../../assets/img/next_button.svg"
            alt="next_button"
            class="img-fluid ml-1"
        /></a>
      </div>
      <p class="text_color font-weight-bold ml-4">UNITS</p>
    </div>
  </div>

  <!-- <section class="hidden" id="dashboard_right">
    <app-navbar></app-navbar>
    <div class="container-fluid">
        <div class="row mt-5">
            <div class="col mt-5 d-flex justify-content-center ml-5">
                <h5 class="ml-2 text_color text-align-right ml-5"> Appliance <br>consumption <br>indicator <span><img
                            src="../../../assets/img/Question_mark.svg" alt="question_mark_img" class="img-fluid"
                            style="width: 20px;"></span> </h5>
            </div>
        </div>

        <div class="row d-flex justify-content-center mt-4">
            <div class="col-3 offset-md-2 col-md-1 border-right border-dark d-flex justify-content-end">
                <img src=" ../../../assets/img/Fridge.svg " alt="Fridge " class="img-fluid " style="width: 30px; ">
            </div>
            <div class="col-2 col-md-2 ">
                <p class="text_color mb-0 ">Fridge</p>
                <h5 class="text-danger ">123<span class="text_color font-weight-bold ml-1 " style="font-size: 13px ">W</span></h5>
            </div>
        </div>
        <div class="row d-flex justify-content-center mt-4">
            <div class="col-3 offset-2 col-md-1 border-right border-dark d-flex justify-content-end">
                <img src="../../../assets/img/Bedroom_AC.svg " alt="Fridge " class="img-fluid " style="width: 50px; ">
            </div>
            <div class="col-4 col-md-2 ">
                <p class="text_color mb-0 ">Bedroom AC</p>
                <h5 class="text-danger ">343<span class="text_color font-weight-bold ml-1 " style="font-size: 13px ">W</span></h5>
            </div>
        </div>
        <div class="row d-flex justify-content-center mt-4">
            <div class="col-3 offset-2 col-md-1 border-right border-dark d-flex justify-content-end">
                <img src="../../../assets/img/Washing_machine.svg " alt="Fridge " class="img-fluid " style="width: 40px; ">
            </div>
            <div class="col-4 col-md-2 ">
                <p class="text_color mb-0 ">Washing machine</p>
                <h5 class="text-danger ">343<span class="text_color font-weight-bold ml-1 " style="font-size: 13px ">W</span></h5>
            </div>
        </div>

        <div class="row mt-3 ">
            <div class="col col-md-4 d-flex justify-content-end ">
                <a class="text_color " (click)="swipe_right()">
                    <----Swipe </a>
            </div>
        </div>
    </div>
</section> -->
</div>

<!-- <div *ngIf="!estimatedConsumption" class="d-block mt-5">
    <h3 class="text-warning text-center mt-5">Loading...</h3>
</div> -->
